import { Card } from '@procurify/ui'
import styled from 'styled-components'

export const CatalogItemDetailsBodyStyled = styled(Card.Content)`
  flex: 1;
  overflow-y: auto;
  padding: 0 ${(props) => props.theme.space.medium}
    ${(props) => props.theme.space.xlarge};
`
